<template>
    <v-btn :href='`mailto:?subject=${subject}&body=${encodeURIComponent(body)}`' :block="block" :color="color" dark target="_blank">
        <v-icon small class="mr-2">fas fa-inbox</v-icon>
        {{ $t('Email') }}
    </v-btn>
</template>

<script>
export default {
    name: 'EmailShare',
    props: {
        subject: {
            type: String,
        },
        body: {
            type: String,
        },
        block: Boolean,
    },
    data() {
        return {
            color: '#F14336',
        };
    },
};
</script>